import React from 'react';
import styles from './TextArea.module.css';
import clsx from 'clsx';

const TextArea = ({
  label,
  value,
  onChange,
  placeholder = '',
  required = false,
  className,
  rows = 4,
  ...props
}) => {
  return (
    <div className={clsx(styles.container, className)}>
      {label && (
        <label className={styles.label}>
          {label} {required && '*'}
        </label>
      )}
      <textarea
        className={styles.textarea}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        {...props}
      />
    </div>
  );
};

export default TextArea;
